import {
  returnAllTradeDetailsFromGenericParams,
  returnOPLegFormThisTrade,
  returnRPLegFromThisTrade,
} from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { statusFromAwarded } from "../../colDefs/colDefsShared";

export function returnCouponValueToRender(
  params: any,
  thisTrade: ExecutionStrategy,
):
  | {
      value: string | number | undefined;
      notation: string | undefined;
    }
  | undefined {
  if (!thisTrade) {
    return;
  }
  const { isOp, isOutright, isLeg, isER } =
    returnAllTradeDetailsFromGenericParams(params);

  const helperObject = {
    params,
    thisTrade,
    isOp,
    isER,
    isOutright,
    isLeg,
  };

  if (isOp) {
    //ER
    // No Return
    if (isLeg || isOutright) {
      const thisOPLeg = returnOPLegFormThisTrade(helperObject);

      return { value: thisOPLeg?.coupon, notation: thisOPLeg?.notation };
    }
  } else {
    //RP
    //ER
    const thisRPLeg = returnRPLegFromThisTrade(helperObject);
    if (isLeg || isOutright) {
      if (
        thisTrade &&
        thisTrade.status &&
        !statusFromAwarded.includes(thisTrade.status)
      ) {
        if (thisRPLeg?.unwind == "Recoupon") {
          return undefined; // Remove the recoupon value until a trade reaches awarded otherwise the RP knows the block will be recouponed.
        }
      }
      return { value: thisRPLeg?.coupon, notation: thisRPLeg?.notation };
    }
  }
  return undefined;
}
